import { type PublicGlobalConfig } from '../../../global-config'

/*
  We use the global discountBoundaries that the shop uses to determine if the discount is valid.
 */
export const productSearchAlgoliaAccessorIsDiscountValid = (
  discount: number,
  discountBoundaries: PublicGlobalConfig['discountBoundaries'],
): boolean => {
  if (!discount || Number.isNaN(discount) || discount <= 0) {
    return false
  }

  if (discountBoundaries) {
    const { max, min } = discountBoundaries

    if (Boolean(min && discount < min) || Boolean(max && discount > max)) {
      return false
    }
  }

  return true
}
